import React from 'react'
import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import { ROLE } from '../auth'
import { PrivateRoute } from '../auth/PrivateRoute'
import ReportTicketsPage from './components/ReportTicketsPage'
import MatchingPayoutReportPage from './components/MatchingPayoutReportPage'
import { MATCHING_PAYOUT_REPORT_ROLES } from './core/consts'

const ReportsPage: React.FC = () => {
  return (
    <Routes>
      <Route
        element={
          <>
            <Outlet />
          </>
        }
      >
        <Route
          path='/payment'
          element={
            <PrivateRoute
              roles={[
                ROLE.ROLE_ADMIN,
                ROLE.ROLE_MANAGER,
                ROLE.ROLE_SENIOR_CASHIER,
                ROLE.ROLE_SENIOR_OPERATOR,
                ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
              ]}
            >
              <ReportTicketsPage key={'payment'} typeReport={'payment'} />
            </PrivateRoute>
          }
        />
        <Route
          path='/payout'
          element={
            <PrivateRoute
              roles={[
                ROLE.ROLE_ADMIN,
                ROLE.ROLE_MANAGER,
                ROLE.ROLE_SENIOR_CASHIER,
                ROLE.ROLE_SENIOR_OPERATOR,
                ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
              ]}
            >
              <ReportTicketsPage key={'payout'} typeReport={'payout'} />
            </PrivateRoute>
          }
        />
        <Route
          path='/matching-payout'
          element={
            <PrivateRoute roles={MATCHING_PAYOUT_REPORT_ROLES}>
              <MatchingPayoutReportPage />
            </PrivateRoute>
          }
        />
        <Route index element={<Navigate to='/payment' />} />
      </Route>
    </Routes>
  )
}

export default ReportsPage
